var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviderline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15998",
    "data-name": "Group 15998",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 346.397,
    height: 22.755,
    viewBox: "0 0 346.397 22.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5753",
    "data-name": "Rectangle 5753",
    width: 176.693,
    height: 22.755,
    transform: "translate(0 0)",
    fill: "#f1bf7a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13407",
    "data-name": "Group 13407",
    transform: "translate(169.705 0)",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10293",
    "data-name": "Path 10293",
    d: "M1.257,12.286c-2.277,2.738-1.381,6.7,2.06,8.812a9.831,9.831,0,0,0,9.369.649A48.5,48.5,0,0,0,22.9,15.319c3.514-2.844,6.386-6.47,9.842-9.4,3.844-3.253,8.325-4.883,13.435-3.116a10.11,10.11,0,0,1,6.788,9.835,9.678,9.678,0,0,1-7.926,8.851c-3.72.732-7.876-1.715-8.769-5.163-.734-2.832.224-5.01,2.629-5.976a5,5,0,0,1,6.211,2.273c.6.986,1.221,1.964,1.831,2.946l.9-.211a10.513,10.513,0,0,0-.277-2.834,6.457,6.457,0,0,0-8.8-3.338,6.35,6.35,0,0,0-2.716,9,8.39,8.39,0,0,0,7.738,4.568A10.271,10.271,0,0,0,53.1,17.676c2.58-4.262,2.183-8.575-.645-12.525C49.348.806,44.91-.7,39.727.292c-4.84.924-8.6,3.775-11.913,7.265-2.26,2.381-4.461,4.818-7.074,7.648.83-3.3,3.7-5.868.568-9.587-.354,1.371-.539,2.093-.727,2.815-.639,2.445-1.288,4.888-1.914,7.336-.852,3.334-3.846,3.651-6.3,4.733,5.932-4.834,7.6-11.152,2.959-13.975.08,1.326.051,2.345.215,3.33.956,5.722-1.653,9.927-8,11.251C3.2,22.013.047,17.4,1.2,12.235Z",
    transform: "translate(121.864 0)",
    fill: "#f1bf7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10294",
    "data-name": "Path 10294",
    d: "M101.167,25.1a27.083,27.083,0,0,0,3.185.37q52.33.028,104.659.044c4.339.007,8.965-1.175,12.517,2.7V21.393c-3.961,3.745-9,2.508-13.757,2.516Q156,24,104.225,23.94h-2.941q-.058.577-.117,1.155",
    transform: "translate(-101.167 -9.481)",
    fill: "#f1bf7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10295",
    "data-name": "Path 10295",
    d: "M76.745,19.3c4.217-4.084,7.422-1.232,10.477,1.938.95-2.283.29-3.563-2.037-4.646A6.215,6.215,0,0,0,76.8,19.347l-.057-.05",
    transform: "translate(46.319 -7.061)",
    fill: "#f1bf7a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15995",
    "data-name": "Group 15995",
    transform: "translate(0 0)",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11206",
    "data-name": "Path 11206",
    d: "M53.572,12.286c2.277,2.738,1.381,6.7-2.06,8.812a9.831,9.831,0,0,1-9.369.649,48.5,48.5,0,0,1-10.215-6.427c-3.514-2.844-6.386-6.47-9.842-9.4C18.242,2.67,13.76,1.041,8.65,2.807a10.11,10.11,0,0,0-6.788,9.835,9.678,9.678,0,0,0,7.926,8.851c3.72.732,7.876-1.715,8.769-5.163.734-2.832-.224-5.01-2.629-5.976a5,5,0,0,0-6.211,2.273c-.6.986-1.221,1.964-1.831,2.946l-.9-.211a10.513,10.513,0,0,1,.277-2.834,6.457,6.457,0,0,1,8.8-3.338,6.35,6.35,0,0,1,2.716,9,8.39,8.39,0,0,1-7.738,4.568,10.271,10.271,0,0,1-9.318-5.079C-.855,13.414-.459,9.1,2.369,5.151,5.481.806,9.918-.7,15.1.292c4.84.924,8.6,3.775,11.913,7.265,2.26,2.381,4.461,4.818,7.074,7.648-.83-3.3-3.7-5.868-.568-9.587.354,1.371.539,2.093.727,2.815.639,2.445,1.288,4.888,1.914,7.336.852,3.334,3.846,3.651,6.3,4.733-5.932-4.834-7.6-11.152-2.959-13.975-.08,1.326-.051,2.345-.215,3.33-.956,5.722,1.653,9.927,8,11.251,4.345.906,7.5-3.708,6.345-8.871Z",
    transform: "translate(0 0)",
    fill: "#f1bf7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11207",
    "data-name": "Path 11207",
    d: "M221.528,25.1a27.083,27.083,0,0,1-3.185.37q-52.33.028-104.659.044c-4.339.007-8.965-1.175-12.517,2.7V21.393c3.961,3.745,9,2.508,13.757,2.516Q166.7,24,218.47,23.94h2.941q.058.577.117,1.155",
    transform: "translate(-44.835 -9.481)",
    fill: "#f1bf7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11208",
    "data-name": "Path 11208",
    d: "M87.641,19.3c-4.217-4.084-7.422-1.232-10.477,1.938-.95-2.283-.29-3.563,2.037-4.646a6.215,6.215,0,0,1,8.383,2.759l.057-.05",
    transform: "translate(-34.012 -7.061)",
    fill: "#f1bf7a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviderline);
export default __webpack_public_path__ + "static/media/deviderline.a4670ce9de3d9608fd9b86c1c5d1e374.svg";
export { ForwardRef as ReactComponent };